import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core'
import { NgForm } from '@angular/forms'
import { DataTableDirective } from 'angular-datatables'
import { Subject, Subscription } from 'rxjs'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { NotificationService } from '../../../services/notification.service'
import { ActivatedRoute } from '@angular/router'
import { CompanyService } from '../../../services/company.service'
import { getLengthTable, getLoggedUser, setLengthTable } from 'src/app/_helpers/LocalStorage'
import { HttpClient } from '@angular/common/http'
import { PATH } from 'src/app/app.api'
import { CompanyServiceProviderService } from 'src/app/services/company-service-provider'
import { CompanyServiceProvider } from 'src/app/models/CompanyServiceProvider'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { SearchTruncated, searchTruncatedCompanyServiceProvider } from 'src/app/_helpers/SearchTruncated'
import { insertOrRemoveClassInScrollButton, scrollToConteiner } from 'src/app/_helpers/Utils'

@Component({
	selector: 'app-company-service-provider',
	templateUrl: './company-service-provider.component.html'
})
export class CompanyServiceProviderComponent implements OnInit, AfterViewInit {

	@ViewChild('form') public form: NgForm
	@ViewChild(DataTableDirective) public dtElement: DataTableDirective
	@ViewChild('tableConteiner')
	public tableConteiner: ElementRef<HTMLDivElement>

	public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}

	public sessionUser: UserAdmin = getLoggedUser()
	public companyId: string = localStorage.getItem('companyId')
	public ViewValidation: ViewValidation = new ViewValidation()

	public isAdmin: boolean = false
	public companyIsActive: boolean = false
	public open: boolean = false
	public openDelete: boolean = false

	public skip: number = 0
	public limit: number = 0
	public order: any
	public typeOrder: any

	public companiesServiceProvider: Array<CompanyServiceProvider> = []
	public companyServiceProvider: CompanyServiceProvider = new CompanyServiceProvider()
	public companyServiceProviderDeleteIdMongo: string = ''

	public filterText: string
	public handlerOperations: Array<any>
	public updateDataTable = value => this.filterHeader(value)

	public companyServiceProviderSearchTruncated: Array<SearchTruncated> = searchTruncatedCompanyServiceProvider
	public searchTruncatedStringFormated: string = ''

	public showScrollUpButton: boolean = false
	public lengthTable: string = getLengthTable()

	public httpListSubscription: Subscription

	constructor(
		public notificationService: NotificationService,
		private companyService: CompanyService,
		private activateRoute: ActivatedRoute,
		private companyServiceProviderService: CompanyServiceProviderService,
		private http: HttpClient

	) {}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	public ngOnInit(): void {
		this.checkCompanyStatus()
		this.checkAssignment()

		this.filterText =
			this.activateRoute.snapshot.queryParams.search ? this.activateRoute.snapshot.queryParams.search : ''

		this.setupDatatables()
		this.setHandlerOperations()

		const observer =
			new IntersectionObserver( ([entry]) => {
				this.showScrollUpButton = entry.isIntersecting

				if (entry.isIntersecting) {
					insertOrRemoveClassInScrollButton()
				}
			})

		observer.observe(this.tableConteiner.nativeElement)
	}

	public checkAssignment() {
		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
	}

	public async checkCompanyStatus(): Promise<void> {
		try {
			const companyStatus: string =
				await this.companyService.checkStatus(this.companyId).toPromise()

			this.companyIsActive = Boolean(companyStatus === 'ACTIVE')
		} catch (err) {}
	}

	private setupDatatables(): void {
		this.datatableOptions = {
			pagingType: 'full_numbers',
			language: {
				processing: 'Processando...',
				lengthMenu: '_MENU_ resultados por página',
				info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
				infoEmpty: 'Mostrando 0 até 0 de 0 registros',
				infoFiltered: '',
				infoPostFix: '',
				zeroRecords: '...',
				loadingRecords: 'Cargando...',
				emptyTable: 'Nenhum registro encontrado',
				paginate: {
					first: 'Primero',
					previous: 'Anterior',
					next: 'Próximo',
					last: 'Último'
				},
				aria: {
					sortAscending: ': Ordenar colunas de forma ascendente',
					sortDescending: ': Ordenar colunas de forma ascendente'
				}
			},
			paging: true,
			searching: true,
			ordering: true,
			destroy: true,
			info: true,
			autoWidth: false,
			pageLength: Number(this.lengthTable),
			lengthChange: false,
			columnDefs: [
				{
					targets: [1],
					width: '.1%'
				}
			],
			order: [[1, 'desc']],
			orderMulti: true,
			serverSide: true,

			ajax: (dataTablesParameters: any, callback) => {
				this.skip = dataTablesParameters.start
				this.limit = dataTablesParameters.length
				this.order = dataTablesParameters.columns[dataTablesParameters.order[0].column].data
				this.typeOrder = dataTablesParameters.order[0].dir
				if (this.httpListSubscription) {
					this.httpListSubscription.unsubscribe()
				}
				this.httpListSubscription = this.http
					.get<any>(`${PATH}/companyServiceProvider/company/${this.companyId}?skip=${dataTablesParameters.start}&limit=${dataTablesParameters.length}&order=${dataTablesParameters.columns[dataTablesParameters.order[0].column].data}&typeOrder=${dataTablesParameters.order[0].dir}&search=${this.filterText}${this.searchTruncatedStringFormated && this.searchTruncatedStringFormated}`)
					.subscribe(resp => {
						callback({
							recordsFiltered: resp.numberOfPages,
							recordsTotal: resp.numberOfPages,
							data: []
						})
						this.companiesServiceProvider = resp.content
					})
			},
			columns: [
				{ data: 'action' , orderable: false },
				{ data: 'socialName' },
				{ data: 'cnpj' },
				{ data: 'address' }
			]
		}
	}

	public async setHandlerOperations() {
		this.handlerOperations =
			await this.companyServiceProviderService.getHandlerOperations(this.companyId).toPromise()
	}

	public filterHeader(value: string): void {
		this.filterText = value
	}

	public async openModalCreateOrEditCompanyProviderService(companyServiceProvider?: CompanyServiceProvider) {
		this.open = true

		if (companyServiceProvider) {
			this.companyServiceProvider = companyServiceProvider
			await this.fetchDetailCompanyServiceProvider()
		} else {
			this.companyServiceProvider = new CompanyServiceProvider()
		}
	}

	public async fetchDetailCompanyServiceProvider() {
		this.companyServiceProvider =
			await this.companyServiceProviderService.getDetailCompanyServiceProvider(
				this.companyId,
				this.companyServiceProvider.idMongo
			).toPromise()
	}

	public async createOrEditCompanyServiceProvider(isEditing: boolean): Promise<void> {
		try {
			this.companyServiceProvider.companyId = this.companyId
			let response

			if (isEditing) {
				response =
					await this.companyServiceProviderService.editCompanyServiceProvider(
						this.companyServiceProvider.idMongo,
						this.companyId,
						this.companyServiceProvider
					).toPromise()
			} else {
				response =
					await this.companyServiceProviderService.newCompanyServiceProvider(
						this.companyId,
						this.companyServiceProvider
					).toPromise()
			}

			this.closeModal()
			this.notificationService.notify(response.message, 200)

		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public openModalDelete(idMongo: string) {
		this.openDelete = true
		this.companyServiceProviderDeleteIdMongo = idMongo
	}

	public async removeCompanyServiceProvider() {
		try {
			const response: any =
				await this.companyServiceProviderService.removeCompanyServiceProvider(
					this.companyId,
					this.companyServiceProviderDeleteIdMongo
				).toPromise()

			await this.closeModal()
			this.notificationService.notify(response.message, 200)
		} catch (err) {}
	}

	public async closeModal(): Promise<void> {
		this.openDelete = false
		this.open = false
		try {
			this.companiesServiceProvider =
				await this.companyServiceProviderService.getCompaniesServiceProvider({
					companyId: this.companyId,
					skip: this.skip,
					limit: this.limit,
					order: this.order,
					typeOrder: this.typeOrder
				}).toPromise()
		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public rerender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public searchTruncated(value: string) {
		this.searchTruncatedStringFormated = value
		this.rerender()
	}

	public updateLengthTable(newLength: string) {
		this.datatableOptions.pageLength = parseInt(newLength)
		this.rerender()
		setLengthTable(newLength)
	}

	public runToInitTable() {
		const table: HTMLDivElement =
			document.getElementsByClassName('datatables-content')[0] as HTMLDivElement

		scrollToConteiner(table)
		insertOrRemoveClassInScrollButton()
	}
}
